import React, { useState } from 'react';

const BhojanHome = () => {
  const [selectedDeliveryPoint, setSelectedDeliveryPoint] = useState('Home');
  const [selectedTiming, setSelectedTiming] = useState('Now');
  const [searchQuery, setSearchQuery] = useState('');

  // Dummy data for restaurants
  const restaurants = [
    { id: 1, name: 'Spice Haven', rating: 4.5, deliveryTime: '25 min', price: '₹200', image: 'https://via.placeholder.com/300x200?text=Spice+Haven' },
    { id: 2, name: 'Burger Bliss', rating: 4.2, deliveryTime: '30 min', price: '₹150', image: 'https://via.placeholder.com/300x200?text=Burger+Bliss' },
    { id: 3, name: 'Veggie Delight', rating: 4.7, deliveryTime: '20 min', price: '₹180', image: 'https://via.placeholder.com/300x200?text=Veggie+Delight' },
    { id: 4, name: 'Pizza Palace', rating: 4.3, deliveryTime: '35 min', price: '₹250', image: 'https://via.placeholder.com/300x200?text=Pizza+Palace' },
    { id: 5, name: 'Sushi Spot', rating: 4.6, deliveryTime: '28 min', price: '₹300', image: 'https://via.placeholder.com/300x200?text=Sushi+Spot' },
  ];

  // Dummy data for cakes
  const cakes = [
    { id: 1, name: 'Chocolate Fudge Cake', price: '₹500', image: 'https://via.placeholder.com/300x200?text=Chocolate+Cake' },
    { id: 2, name: 'Red Velvet Cake', price: '₹450', image: 'https://via.placeholder.com/300x200?text=Red+Velvet' },
    { id: 3, name: 'Vanilla Dream Cake', price: '₹400', image: 'https://via.placeholder.com/300x200?text=Vanilla+Cake' },
  ];

  // Dummy data for coupons
  const coupons = [
    { id: 1, code: 'WELCOME10', discount: '10% off first order', expiry: 'Nov 30, 2025' },
    { id: 2, code: 'DELIVERFREE', discount: 'Free delivery on orders over ₹300', expiry: 'Dec 15, 2025' },
    { id: 3, code: 'PARTY20', discount: '20% off party food', expiry: 'Nov 10, 2025' },
  ];

  const deliveryPoints = ['Home', 'Office', 'Party', 'Anywhere'];
  const timings = ['Now', 'Later'];

  const filteredRestaurants = restaurants.filter(restaurant =>
    restaurant.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="bg-gray-900 text-white p-4">
      <header className="flex justify-between items-center mb-6">
        <div className="flex flex-col items-start">
          <h1 className="text-xl lg:text-2xl font-bold">Bhojan</h1>
          <p className="text-sm text-left  text-white">Your Fooding Experienec with AI</p>
        </div>
        <div className="w-8 h-8 bg-gray-800 rounded-full flex items-center justify-center">
          <span className="text-xs">👤</span>
        </div>
      </header>

      <div className="bg-gray-900 text-white px-4 py-6">
        <div className="mx-auto w-full">

        {/* Search Bar */}
        <div className="mb-6 w-full">
          <input
            type="text"
            placeholder="Search for restaurants, dishes..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full p-3 bg-gray-800 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        {/* Delivery Options */}
        <div className="mb-6">
          <h2 className="text-lg font-semibold mb-3">Delivery Options</h2>
          <div className="grid grid-cols-3 lg:grid-cols-6 gap-1 mb-3">
            {deliveryPoints.map(point => (
              <button
                key={point}
                onClick={() => setSelectedDeliveryPoint(point)}
                className={`p-3 rounded-lg text-center ${
                  selectedDeliveryPoint === point
                    ? 'bg-blue-600 text-white'
                    : 'bg-gray-800 text-gray-300 hover:bg-gray-700'
                }`}
              >
                {point}
              </button>
            ))}
          </div>
          <div className="grid grid-cols-3 lg:grid-cols-6 gap-3">
            {timings.map(timing => (
              <button
                key={timing}
                onClick={() => setSelectedTiming(timing)}
                className={`p-3 rounded-lg text-center ${
                  selectedTiming === timing
                    ? 'bg-green-600 text-white'
                    : 'bg-gray-800 text-gray-300 hover:bg-gray-700'
                }`}
              >
                {timing}
              </button>
            ))}
          </div>
          <p className="text-sm text-gray-400 mt-2">
            Selected: {selectedDeliveryPoint} Delivery - {selectedTiming}
          </p>
        </div>

        {/* Quick Services */}
        <div className="mb-6">
          <h2 className="text-lg font-semibold mb-3">Quick Services</h2>
          <div className="grid grid-cols-3 lg:grid-cols-3 gap-3">
            <button className="p-4 bg-gray-800 rounded-lg hover:bg-gray-700 transition-colors">
              <h3 className="font-medium">Tiffin Service</h3>
              <p className="text-sm text-gray-400">Make My Tiffin / Choose Tiffin</p>
            </button>
            <button className="p-4 bg-gray-800 rounded-lg hover:bg-gray-700 transition-colors">
              <h3 className="font-medium">Catering Service</h3>
              <p className="text-sm text-gray-400">For events & parties</p>
            </button>
            <button className="p-4 bg-gray-800 rounded-lg hover:bg-gray-700 transition-colors col-span-2">
              <h3 className="font-medium">Table Booking</h3>
              <p className="text-sm text-gray-400">Reserve at restaurants</p>
            </button>
          </div>
        </div>
      </div>
      </div>

      {/* Restaurants Section */}
      <div className="mb-6">
        <h2 className="text-lg font-semibold mb-3">Restaurants Near You</h2>
        <div className="space-y-4">
          {filteredRestaurants.map(restaurant => (
            <div key={restaurant.id} className="bg-gray-800 rounded-lg p-3 flex justify-between items-center">
              <img src={restaurant.image} alt={restaurant.name} className="w-24 h-24 object-cover" />

              <div>
                <h3 className="font-medium">{restaurant.name}</h3>
                <p className="text-sm text-gray-400">⭐ {restaurant.rating} • {restaurant.deliveryTime} • {restaurant.price}</p>
              </div>
              <button className="px-3 py-1 w-24 bg-blue-600 rounded text-sm hover:bg-green-700 transition-colors">
                 Order Now
              </button>
            </div>
          ))}
        </div>
      </div>

      {/* Party Food & Cakes */}
      <div className="mb-6">
        <h2 className="text-lg font-semibold mb-3">Specials</h2>
        <div className="grid grid-cols-2 lg:grid-cols-6 gap-4">
          {/* Party Food */}
          <div className="bg-gray-800 rounded-lg p-4">
            <h3 className="font-medium mb-2">Party Food</h3>
            <p className="text-sm text-gray-400 mb-3">Plates for celebrations</p>
            <button className="w-full px-4 py-2 bg-purple-600 rounded-lg hover:bg-purple-700 transition-colors">
              Explore
            </button>
          </div>
          {/* Cakes */}
          <div className="bg-gray-800 rounded-lg p-4">
            <h3 className="font-medium mb-2">Cakes</h3>
            <div className="space-y-2">
              {cakes.map(cake => (
                <div key={cake.id} className="text-sm">
                  <p>{cake.name} - {cake.price}</p>
                </div>
              ))}
            </div>
            <button className="w-full mt-3 px-4 py-2 bg-pink-600 rounded-lg hover:bg-pink-700 transition-colors text-sm">
              View All
            </button>
          </div>
        </div>
      </div>

      {/* Coupons */}
      <div className="mb-6">
        <h2 className="text-lg font-semibold mb-3">Coupons</h2>
        <div className="space-y-3">
          {coupons.map(coupon => (
            <div key={coupon.id} className="bg-gray-800 rounded-lg p-3 flex justify-between items-center">
              <div>
                <h3 className="font-medium">{coupon.code}</h3>
                <p className="text-sm text-gray-400">{coupon.discount}</p>
                <p className="text-xs text-gray-500">Expires: {coupon.expiry}</p>
              </div>
              <button className="px-3 py-1 w-24 bg-green-600 rounded text-sm hover:bg-green-700 transition-colors">
                Apply
              </button>
            </div>
          ))}
        </div>
      </div>

      {/* Footer Note */}
      <footer className="text-center text-sm text-gray-500 py-4">
        (c) Bhojan by Think5Whys Global DeepTech Solutions 
      </footer>
    </div>
  );
};

export default BhojanHome;